import cx from "classnames";
import Link from "next/link";
import ImageWithFallback from "@/components/Image";
import { NflGameState } from "../findGameState";
import type { Team } from "../types";
import styles from "./teams.module.scss";

interface TeamsProps {
  homeTeam?: Team | null;
  awayTeam?: Team | null;
  isMobile?: boolean;
  isTooSmallForFullNames?: boolean;
  isTablet?: boolean;
  gameState?: NflGameState;
  clock?: string;
  quarter?: string;
  homeScore: number | null;
  awayScore: number | null;
}

const Teams = ({
  homeTeam,
  awayTeam,
  isMobile,
  isTooSmallForFullNames,
  isTablet,
  gameState,
  clock,
  quarter,
  homeScore,
  awayScore,
}: TeamsProps) => {
  const findCorrectName = (
    code: string | undefined | null,
    shortName: string | undefined | null,
    name: string | undefined | null
  ) => {
    if (isMobile) {
      return code;
    } else if (isTooSmallForFullNames && !isTablet) {
      return shortName;
    } else {
      return name;
    }
  };
  const homeName = findCorrectName(
    homeTeam?.code,
    homeTeam?.shortName,
    homeTeam?.name
  );
  const awayName = findCorrectName(
    awayTeam?.code,
    awayTeam?.shortName,
    awayTeam?.name
  );

  const homeLost =
    homeScore != null && awayScore != null && awayScore > homeScore;
  const awayLost =
    homeScore != null && awayScore != null && awayScore < homeScore;

  return (
    <div className={styles.teams}>
      <div className={styles.team}>
        <Link
          href={`https://sportsbook.fanduel.com/teams/nfl/${awayTeam?.slug ?? ""}`}
        >
          <h2>{awayName ?? "Away"}</h2>
        </Link>

        <ImageWithFallback
          src={awayTeam?.icon}
          width={60}
          height={60}
          alt={awayTeam?.name ? `Logo for ${awayTeam?.name}` : "Away team logo"}
        />
        {gameState === "LIVE" || gameState === "POST" ? (
          <span className={cx(styles.score, awayLost && styles.loser)}>
            {awayScore}
          </span>
        ) : null}
      </div>
      {gameState === "PRE" ? <p>@</p> : null}
      {gameState === "LIVE" ? (
        <div className={styles.time}>
          <p className={styles.clock}>{clock}</p>
          <p className={styles.quarter}>
            {quarter ? `${quarter} ${isMobile ? "Qtr" : "Quarter"}` : ""}
          </p>
        </div>
      ) : null}
      {gameState === "POST" ? <p>Final</p> : null}

      <div className={cx(styles.team, styles.home)}>
        {gameState === "LIVE" || gameState === "POST" ? (
          <span className={cx(styles.score, homeLost && styles.loser)}>
            {homeScore}
          </span>
        ) : null}
        <ImageWithFallback
          src={homeTeam?.icon}
          width={60}
          height={60}
          alt={homeTeam?.name ? `Logo for ${homeTeam?.name}` : "Home Team Logo"}
        />
        <Link
          href={`https://sportsbook.fanduel.com/teams/nfl/${homeTeam?.slug ?? ""}`}
        >
          <h2>{homeName ?? "Home"}</h2>
        </Link>
      </div>
    </div>
  );
};

export default Teams;
